// extracted by mini-css-extract-plugin
module.exports = {"prospectsPage":"ProspectsPage_prospectsPage__3_iVw"};